<template>
    <div class="header_sales_analysis is-full-width px-5 py-2">
        <p class="title">Análisis de Ventas</p>

        <div class="right_cluster is-flex is-align-items-center">
            <div v-if="endMonth" class="calendar_picker is-flex is-align-items-center">
                <AnualCalendar
                    :value="endMonth"
                    :disable-newer-dates="true"
                    :disabled-from="getNow"
                    format-label-date="MMMM YYYY"
                    :align-right="true"
                    @date-change="onDateChange" />
            </div>

            <ReportExportButton class="ml-3 drawer_export" />

            <button class="close_btn ml-3" aria-label="Cerrar modal" @click="$emit('close-modal')">
                <Ecs class="ecs" />
            </button>
        </div>
    </div>
</template>

<script>
import Ecs from "@/components/svg/Ecs.vue";
import AnualCalendar from "@/components/classification/AnualCalendar.vue";
import ReportExportButton from "@/components/financialReports/ReportExportButton.vue";

export default {
    name: "HeaderSalesAnalysis",
    components: { Ecs, AnualCalendar, ReportExportButton },
    props: {
        // Shape esperado por ModalFullHeightRight.headerProps:
        // - periodLabel: String — sólo se usa si endMonth no viene
        // - endMonth: Date — mes focal del drawer; alimenta AnualCalendar
        // - getNow: Date — cota superior (mes actual) para deshabilitar futuro
        payload: {
            type: Object,
            default: () => ({
                periodLabel: "",
                endMonth: null,
                getNow: null,
            }),
        },
    },
    computed: {
        periodLabel() {
            return this.payload?.periodLabel ?? "";
        },
        endMonth() {
            return this.payload?.endMonth ?? null;
        },
        getNow() {
            return this.payload?.getNow ?? null;
        },
    },
    methods: {
        onDateChange(date) {
            this.$emit("update-end-month", date);
        },
    },
};
</script>

<style scoped lang="scss">
// Título a la izquierda, cluster de acciones (calendar / export / cerrar) a la
// derecha. Sin la columna central de filtros: el análisis ya muestra la
// composición por cuenta/categoría/producto en la card de distribución.
.header_sales_analysis {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.title {
    color: var(--report-text);
    font-size: 28px;
    font-weight: 700;
    letter-spacing: -0.4px;
    margin: 0;
}

.right_cluster {
    flex-shrink: 0;
}

.calendar_picker {
    border-radius: 8px;
}

// Botón compartido del export (decisiones §34): trae su propio estilo;
// acá solo se iguala la altura con el resto de los controles del header.
.drawer_export.export_btn {
    height: 46px;
}

.close_btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--report-border-soft);
    background: var(--report-bg);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
    box-sizing: border-box;
    overflow: hidden;
    padding-top: 5px;
    cursor: pointer;

    .ecs {
        width: 100%;
        position: relative;
        height: 20px;
        overflow: hidden;
        flex-shrink: 0;
    }
}
</style>
